import { Injectable } from '@angular/core';
import { AppService } from './app.service';
import { APIConstant } from '../constants/APIConstants';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminInvoiceReportService {
  constructor(private appService: AppService) {}

  getAll(params: {
    pageNumber: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: string;
    Criteria?: string;
    MinDate?: string;
    MaxDate?: string;
    RHId?: string;
    Status?: string;
    MDA?: string;
    EngineCode?: string;
    TaxPayerCategory?: string;
    typ: 'invoices';
  }) {
    return this.appService.get(
      `${APIConstant.adminInvoiceReport.getAll}`,
      params,
    );
  }

  getAllEnhanced(params: {
    pageNumber: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: string;
    Criteria?: string;
    MinDate?: string;
    MaxDate?: string;
    Year?: number;
    Month?: number;
    PaymentGateway?: string;
    PaymentChannel?: string;
    TaxPayerCategory?: string;
    EngineCode?: string;
    MDA?: string;
    typ: 'invoices';
  }) {
    return lastValueFrom(
      this.appService.get(
        `${APIConstant.adminInvoiceReport.getAllEnhanced}`,
        params,
      ),
    );
  }

  getAllForDownload(params: {
    pageNumber?: number;
    pageSize?: number;
    MinDate?: string;
    MaxDate?: string;
  }) {
    return lastValueFrom(
      this.appService.get(
        `${APIConstant.adminInvoiceReport.getAllForDownload}`,
        params,
      ),
    );
  }

  getOne(params: { id: string }) {
    return this.appService.get(
      `${APIConstant.adminInvoiceReport.getOne}`,
      params,
    );
  }

  getCards(params: { Month: number; Year: number }) {
    return this.appService.get(
      `${APIConstant.adminInvoiceReport.getAnalytics}`,
      params,
    );
  }

  async getAllTspCards(params: {
    Month?: string;
    Year?: string;
    MDA?: string;
    EngineCode?: string;
    TaxPayerCategory?: string;
    PaymentGateway?: string;
    PaymentChannel?: string;
  }) {
    const promise = [
      this.getTspCards(params),
      // this.getTspTopMdaCard(params),
      // this.getTspTopRhCard(params),
      // this.getTspTopTaxOfficeCard(params),
    ];

    const [tspCards, topMda, topRh, topTaxOffice] = await Promise.all(promise);

    return {
      tspCards,
      topMda,
      topRh,
      topTaxOffice,
    };
  }

  getTspTopMdaCard(params: { Month?: number; Year?: number }) {
    return lastValueFrom(
      this.appService.get(
        `${APIConstant.adminInvoiceReport.getTspTopMdaCard}`,
        params,
      ),
    );
  }

  getTspTopRhCard(params: { MinDate?: string; MaxDate?: string }) {
    return lastValueFrom(
      this.appService.get(
        `${APIConstant.adminInvoiceReport.getTspTopRhCard}`,
        params,
      ),
    );
  }

  getTspTopTaxOfficeCard(params: { Month?: number; Year?: number }) {
    return lastValueFrom(
      this.appService.get(
        `${APIConstant.adminInvoiceReport.getTspTopTaxOfficeCard}`,
        params,
      ),
    );
  }

  getTspCards(params: { Month?: string; Year?: string }) {
    return lastValueFrom(
      this.appService.get(
        `${APIConstant.adminInvoiceReport.getTspCards}`,
        params,
      ),
    );
  }
}
